import { Helmet } from 'react-helmet-async';
import { useState, useEffect, React, useContext } from 'react';
import { Grid, Container, Typography } from '@mui/material';
import axios from 'axios';
import api from '../services/api';
import { AppWidgetSummary } from '../sections/@dashboard/app';
import '../utils/style.css';
import { GenerationContext } from '../context';

export default function DashboardAppPage() {
  const { selectedGeneration } = useContext(GenerationContext);
  const [bugPokemons, setBugPokemons] = useState([]);
  const [darkPokemons, setDarkPokemons] = useState([]);
  const [dragonPokemons, setDragonPokemons] = useState([]);
  const [electricPokemons, setElectricPokemons] = useState([]);
  const [fairyPokemons, setFairyPokemons] = useState([]);
  const [fightingPokemons, setFightingPokemons] = useState([]);
  const [firePokemons, setFirePokemons] = useState([]);
  const [flyingPokemons, setFlyingPokemons] = useState([]);
  const [ghostPokemons, setGhostPokemons] = useState([]);
  const [grassPokemons, setGrassPokemons] = useState([]);
  const [groundPokemons, setGroundPokemons] = useState([]);
  const [icePokemons, setIcePokemons] = useState([]);
  const [normalPokemons, setNormalPokemons] = useState([]);
  const [poisonPokemons, setPoisonPokemons] = useState([]);
  const [psychicPokemons, setPsychicPokemons] = useState([]);
  const [rockPokemons, setRockPokemons] = useState([]);
  const [steelPokemons, setSteelPokemons] = useState([]);
  const [waterPokemons, setWaterPokemons] = useState([]);

  useEffect(() => {
    if (selectedGeneration === 'allgen') {
      getPokemons(1, 906);
    }
    if (selectedGeneration === 'gen1') {
      getPokemons(1, 151);
    }
    if (selectedGeneration === 'gen2') {
      getPokemons(152, 251);
    }
    if (selectedGeneration === 'gen3') {
      getPokemons(252, 386);
    }
    if (selectedGeneration === 'gen4') {
      getPokemons(387, 493);
    }
    if (selectedGeneration === 'gen5') {
      getPokemons(494, 649);
    }
    if (selectedGeneration === 'gen6') {
      getPokemons(650, 721);
    }
    if (selectedGeneration === 'gen7') {
      getPokemons(722, 809);
    }
    if (selectedGeneration === 'gen8') {
      getPokemons(810, 906);
    }

    async function getPokemons(dexinit, dexend) {
      const endpoints = [];

      for (let index = dexinit; index < dexend; index += 1) {
        endpoints.push(`pokemon/${index}/`);
      }
      try {
        const cachedPokemons = await axios.all(endpoints.map((endpoint) => api.get(endpoint)));

        // Buscar as gerações de todos os Pokémons
        const speciesEndpoints = cachedPokemons.map((cachedPokemon) => 
          `pokemon-species/${cachedPokemon.data.id}/`
        );
        const cachedSpecies = await axios.all(speciesEndpoints.map((endpoint) => api.get(endpoint)));

        const tempBugPokemons = [];
        const tempDarkPokemons = [];
        const tempDragonPokemons = [];
        const tempElectricPokemons = [];
        const tempFairyPokemons = [];
        const tempFightingPokemons = [];
        const tempFirePokemons = [];
        const tempFlyingPokemons = [];
        const tempGhostPokemons = [];
        const tempGrassPokemons = [];
        const tempGroundPokemons = [];
        const tempIcePokemons = [];
        const tempNormalPokemons = [];
        const tempPoisonPokemons = [];
        const tempPsychicPokemons = [];
        const tempRockPokemons = [];
        const tempSteelPokemons = [];
        const tempWaterPokemons = [];

        cachedPokemons.forEach((cachedPokemon, index) => {
          const pokemon = cachedPokemon.data;
          const species = cachedSpecies[index].data;
          const generation = species.generation.name;

          if (pokemon.types.some((type) => type.type.name.includes('bug'))) {
            tempBugPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('dark'))) {
            tempDarkPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('dragon'))) {
            tempDragonPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('electric'))) {
            tempElectricPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('fairy'))) {
            tempFairyPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('fighting'))) {
            tempFightingPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('fire'))) {
            tempFirePokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('flying'))) {
            tempFlyingPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('ghost'))) {
            tempGhostPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('grass'))) {
            tempGrassPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('ground'))) {
            tempGroundPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('ice'))) {
            tempIcePokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('normal'))) {
            tempNormalPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('poison'))) {
            tempPoisonPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('psychic'))) {
            tempPsychicPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('rock'))) {
            tempRockPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('steel'))) {
            tempSteelPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }

          if (pokemon.types.some((type) => type.type.name.includes('water'))) {
            tempWaterPokemons.push({ id: pokemon.id, name: pokemon.name, image: pokemon.sprites.front_default, types: pokemon.types, generation });
          }
        });

        setBugPokemons(tempBugPokemons);
        setDarkPokemons(tempDarkPokemons);
        setDragonPokemons(tempDragonPokemons);
        setElectricPokemons(tempElectricPokemons);
        setFairyPokemons(tempFairyPokemons);
        setFightingPokemons(tempFightingPokemons);
        setFirePokemons(tempFirePokemons);
        setFlyingPokemons(tempFlyingPokemons);
        setGhostPokemons(tempGhostPokemons);
        setGrassPokemons(tempGrassPokemons);
        setGroundPokemons(tempGroundPokemons);
        setIcePokemons(tempIcePokemons);
        setNormalPokemons(tempNormalPokemons);
        setPoisonPokemons(tempPoisonPokemons);
        setPsychicPokemons(tempPsychicPokemons);
        setRockPokemons(tempRockPokemons);
        setSteelPokemons(tempSteelPokemons);
        setWaterPokemons(tempWaterPokemons);
      } catch (error) {
        // Error handling silently
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGeneration]);

  return (
    <>
      <Helmet>
        <title> Dashboard | Pokemon </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography 
          variant="h4" 
          sx={{ 
            mb: { xs: 1.5, sm: 2 },
            fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
            fontWeight: 700,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Pokémon Dashboard
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            mb: { xs: 3, sm: 4, md: 5 },
            fontSize: { xs: '0.875rem', sm: '1rem' },
            color: 'text.secondary',
            fontWeight: 500
          }}
        >
          Click on any type card to explore all Pokémon of that type
        </Typography>
        <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }}>
          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={bugPokemons.length === 0 ? 'loading' : 'bug'}
              title="Bug"
              total={bugPokemons.length}
              pokemons={bugPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={darkPokemons.length === 0 ? 'loading' : 'dark'}
              title="Dark"
              total={darkPokemons.length}
              pokemons={darkPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={dragonPokemons.length === 0 ? 'loading' : 'dragon'}
              title="Dragon"
              total={dragonPokemons.length}
              pokemons={dragonPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={electricPokemons.length === 0 ? 'loading' : 'electric'}
              title="Electric"
              total={electricPokemons.length}
              pokemons={electricPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={fairyPokemons.length === 0 ? 'loading' : 'fairy'}
              title="Fairy"
              total={fairyPokemons.length}
              pokemons={fairyPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={fightingPokemons.length === 0 ? 'loading' : 'fighting'}
              title="Fighting"
              total={fightingPokemons.length}
              pokemons={fightingPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={firePokemons.length === 0 ? 'loading' : 'fire'}
              title="Fire"
              total={firePokemons.length}
              pokemons={firePokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={flyingPokemons.length === 0 ? 'loading' : 'flying'}
              title="Flying"
              total={flyingPokemons.length}
              pokemons={flyingPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={ghostPokemons.length === 0 ? 'loading' : 'ghost'}
              title="Ghost"
              total={ghostPokemons.length}
              pokemons={ghostPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={grassPokemons.length === 0 ? 'loading' : 'grass'}
              title="Grass"
              total={grassPokemons.length}
              pokemons={grassPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={groundPokemons.length === 0 ? 'loading' : 'ground'}
              title="Ground"
              total={groundPokemons.length}
              pokemons={groundPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={icePokemons.length === 0 ? 'loading' : 'ice'}
              title="Ice"
              total={icePokemons.length}
              pokemons={icePokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={normalPokemons.length === 0 ? 'loading' : 'normal'}
              title="Normal"
              total={normalPokemons.length}
              pokemons={normalPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={poisonPokemons.length === 0 ? 'loading' : 'poison'}
              title="Poison"
              total={poisonPokemons.length}
              pokemons={poisonPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={psychicPokemons.length === 0 ? 'loading' : 'psychic'}
              title="Psychic"
              total={psychicPokemons.length}
              pokemons={psychicPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={rockPokemons.length === 0 ? 'loading' : 'rock'}
              title="Rock"
              total={rockPokemons.length}
              pokemons={rockPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={steelPokemons.length === 0 ? 'loading' : 'steel'}
              title="Steel"
              total={steelPokemons.length}
              pokemons={steelPokemons}
            />
          </Grid>

          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <AppWidgetSummary
              className={waterPokemons.length === 0 ? 'loading' : 'water'}
              title="Water"
              total={waterPokemons.length}
              pokemons={waterPokemons}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
